import { createSlice } from '@reduxjs/toolkit';
import { apiGet } from 'src/lib/api/axios';
import { markLegacyNotificationsAsRead } from 'src/features/notifications/api';

const initialState = {
  isLoading: false,
  error: null,
  notifications: [],
  unreadCount: 0,
  globalError: { error: null, actions: undefined }
};

const slice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    setGlobalError(state, { payload }) {
      state.globalError = payload;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getNotificationsSuccess(state, action) {
      state.isLoading = false;
      state.notifications = action.payload;
      state.unreadCount = action.payload.filter((notification) => notification.status === 'unread').length;
    },
    markAsReadSuccess(state, action) {
      const notificationIds = action.payload;
      state.notifications = state.notifications.map((notification) =>
        notificationIds.includes(notification.id) ? { ...notification, status: 'read' } : notification
      );
      state.unreadCount = state.notifications.filter((n) => n.status === 'unread').length;
    }
  }
});

export default slice.reducer;
export const { setGlobalError } = slice.actions;

export function getNotifications() {
  return async (dispatch, getState) => {
    const user = getState().profile?.profileData;
    if (user?.user_id) {
      dispatch(slice.actions.startLoading());
      try {
        const response = await apiGet('/notifications/user', {
          skipTenantPrefix: true,
          meta: {
            background: true, // Background data fetch
            context: 'notifications-fetch'
          }
        });
        dispatch(slice.actions.getNotificationsSuccess(response.data));
      } catch (error) {
        dispatch(slice.actions.hasError(error.parsed?.description || 'Failed to fetch notifications'));
      }
    }
  };
}

export function markNotificationsAsRead(notificationIds) {
  return async (dispatch) => {
    try {
      await markLegacyNotificationsAsRead(notificationIds);
      dispatch(slice.actions.markAsReadSuccess(notificationIds));
    } catch (error) {
      dispatch(slice.actions.hasError(error.parsed?.description || 'Failed to mark notifications as read'));
    }
  };
}
